export const DEFAULT_SUGGESTED_QUESTIONS = [
  "What can you help me with?",
  "How do I get started?",
  "Tell me about your features",
  "How do I add a new appliance to an organization?",
  "How do I remove an account from an organization?",
  "How do I invite a new user?",
  "How can I view the logs for an appliance?",
  "Show me the health status of all my appliances",
  "Can you check if any SSL certificates are expiring soon?",
  "How many users are active in my organization?",
  "Which users in my organization have 2FA enabled?",
  "Which accounts have multiple critical alerts triggered in the last 24 hours?",
  "Which destinations are actively receiving alerts?",
  "Which users are currently logged in?",
  "which accounts have most alerts?",
  "What are the most common user roles across all accounts?",
  "Which accounts have the most number of alerts?",
  "which accounts have the least number of alerts?",
  "Show me recent system notifications",
  "What's the current traffic usage across my appliances?",
  "How do I configure alert destinations?",
  "What security settings should I review?",
  "How can I monitor service performance?",
  "Show me the latest system updates available",
  "How do I set up firewall rules?",
  "What are my backup and recovery options?",
  "Show me bandwidth usage trends",
  "How do I manage user permissions?",
];